module.exports = __webpack_public_path__ + "static/media/yumi.91bdaf7a.png";